import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Collapse } from 'reactstrap';
import _ from 'lodash';
import { ProgressButton } from '../../../commons/ProgressButton.js';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from './services.js';
import Loader from '../../../commons/loader.js';
import NetworkEmptyState from '../../../commons/networkemptystate.js';
import QueryEmptyState from '../../../commons/queryempty.js';
import DataEmptyState from '../../../commons/dataemptystate.js';
import Lib from '../../../commons/lib.js';
import RFForm from '../../../components/Form/RFForm.js';
import SelectField from '../../../components/Form/SelectField.js';
import RFField from '../../../components/Form/RFField.js';
import getTooltip from './KeszletszintTooltips.js';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip.js';
import Treeview from '../../../commons/Treeview.js';
import SlaveAvInput from '../../../commons/SlaveAvInput.js';
import NumberFormatter from '../../../commons/NumberFormatter.js';

class KeszletszintLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cikkLoading: false,
      raktarCollapseIsOpen: false,
      modalNezet: false,
      keszletszintJson: [],
      modalInsert: false,
      modalEdit: false,
      modalDelete: false,
      modalDeleteGroup: false,
      editObj: {},
      listLoadingButton: false,
      selectedIds: [],
      tableStatus: 'QUERY', // [LOAD', NETW', 'LIST', 'QUERY', DATA]

      // Raktárankénti készletszint sorokat reprezentálja, azon belül tárolja a sorban kiválasztott raktárok id-it, például: [[1,2,3],[5,6]]
      formRaktarRows: [],
      formRaktarRowsKeszletszintValues: [],

      // FILTER VALUES
      filterCikkcsoport: null,
      filterCikk: null, 

      lekerdezesButtonLoading: false,
      saveButtonLoading: false,
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidMount() {
    this.listCikkcsoport();
    this.listRaktar();
  }

  updateTable = () => {
    const {
      filterCikk,
      filterCikkcsoport
    } = this.state;

    this.setState({ listLoadingButton: true, tableStatus: 'LOAD' }, () => {
      Service.listKeszletszint(filterCikkcsoport ? filterCikkcsoport.id : null, filterCikk ? filterCikk.id : null, (err, res) => {
        if (!err) {
          this.setState({ 
            keszletszintJson: res[0],
            listLoadingButton: false,
            tableStatus: res[0] && res[0].length > 0 ? 'LIST' : 'DATA',
            selectedIds: [],
          });
        } else {
          this.setState({
            listLoadingButton: false,
            tableStatus: err && err.responseJSON && err.responseJSON.hibaazon == 'EMPTY_FILTERS' ? 'QUERY' : 'NETW', 
          });
        }
      });
    });
  }

  deleteKeszletszint = (id) => {
    if (this.state.modalDeleteGroup) {
      this.setState({deleteButtonLoading: true}, () => {
        Service.deleteKeszletszintGroup(id, (err) => {
          if (!err) {
            if (this.state.filterCikkcsoport || this.state.filterCikk)
              this.updateTable();
            this.handleDeleteClick();
            this.props.globals.addSuccess('Kijelölt készletszintek törölve!');
          }
          this.setState({deleteButtonLoading: false});
        })
      });
    } else {
      this.setState({deleteButtonLoading: true}, () => {
        Service.deleteKeszletszint(id, (err) => {
          if (!err) {
            if (this.state.filterCikkcsoport || this.state.filterCikk)
              this.updateTable();
            this.handleDeleteClick();
            this.props.globals.addSuccess('Készletszint törölve!');
          }
          this.setState({deleteButtonLoading: false});
        })
      });
    }
  }

  handleAddKeszletszint = () => {
    this.setState(prevState => ({ 
      modalInsert: !prevState.modalInsert, 
      cikkJson: [], 
      formRaktarRows: [], 
      formRaktarRowsKeszletszintValues: [], 
      cikkTree: [], 
      formCikkcsoportIds: null, 
      formCikkIds: null
    }));
  }

  handleEditClick = (id) => {
    this.setState(prevState => ({ modalEdit: !prevState.modalEdit, editObj: prevState.keszletszintJson.find(x => x.id === id) || {} }));
  }

  handleDeleteClick = (id, group) => {
    if (id) this._currentDeleteId = id;
    this.setState({
      modalDelete: !this.state.modalDelete,
      modalDeleteGroup: group,
    });
  }

  handleCikkCsoportSelect = (cikkcsoportArray) => {
    this.setState({ formCikkcsoportIds: cikkcsoportArray.map(cikkcsoport => cikkcsoport.id) });
  }

  handleCikkSelect = (cikkArray) => {
    this.setState({ formCikkIds: cikkArray.map(cikk => cikk.id) });
  }

  listCikk = () => {
    this.setState({lekerdezesButtonLoading: true});
    Service.listKeszletszintCikk(this.state.formCikkcsoportIds, this.state.formCikkIds, (err, res) => {
      if (!err) {
        let cikkTree = res[0];
        cikkTree.forEach((cikkcsoport) => {
          cikkcsoport.isExpanded = true;
          cikkcsoport.name = cikkcsoport.nev;
          cikkcsoport.cikkek.forEach((cikk) => {
            cikk.name = cikk.megnevezes + ' (' + cikk.mennyisegiEgyseg + ')';
            if (this.state.formCikkIds?.includes(cikk.id))
              cikk.isChecked = true;
          });
          cikkcsoport.children = cikkcsoport.cikkek;
        });
        this.setState({
          cikkTree,
        });
      }
      this.setState({lekerdezesButtonLoading: false});
    });
  }

  listCikkcsoport = () => {
    Service.queryCikkcsoport(null, (err, res) => {
      if (!err) {
        let cikkcsoportArray = res[0];
        cikkcsoportArray.sort((a,b)=>a.nev.localeCompare(b.nev));
        this.setState({ cikkcsoportJson: cikkcsoportArray });
      }
    });
  }

  listRaktar = () => {
    Service.queryRaktar(null, (err, res) => {
      if (!err) {
        this.setState({ raktarJson: res[0] });
      }
    });
  }

  handleUpdateCikkInput = (value, { action }) => {
    switch (action) {
      case 'input-change':
        if (value) {
          this.setState({ cikkLoading: true }, () => {
            Service.queryCikk(value, false, false, this.state.filterCikkcsoport?.id, (err, res) => {
              if (!err) {
                this.setState({ cikkJson: res[0] });
              }
              this.setState({ cikkLoading: false });
            });
          });
        }
        break;
      default:
    }
  }

  hasKarb = () => {
    return this.props.globals.hasRole(['KESZLETNYILV_KESZLETSZINT'], true);
  }

  iconFormatter = (cell, row) => {
    return (
      <React.Fragment>
        {this.hasKarb() &&
          <>
            <Button className="icon-pencil table-action-icon" id={'keszletszint-edit-' + row.id} onClick={() => this.handleEditClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'keszletszint-edit-' + row.id} delay={40}> {'Módosítás'} </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'keszletszint-delete-' + row.id} onClick={() => this.handleDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'keszletszint-delete-' + row.id} delay={40}> {'Törlés'} </UncontrolledTooltip>
          </>
        }
        
      </React.Fragment>
    ); 
  }

  renderFilters = () => {
    const {
      filterCikk,
      filterCikkcsoport,
    } = this.state;
    return (
      <React.Fragment>
        <RFForm onSubmit={() => {}}>
          <div className="row">
            <div className="col-md-3">
              <SelectField
                label='Cikkcsoport:'
                name="filterCikkcsoport"
                id="filterCikkcsoport"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                onChange={v => {
                  this.setState({ filterCikkcsoport: v })
                  if (v)
                    this.setState({ filterCikk: null, cikkJson: [] });
                }}
                options={this.state.cikkcsoportJson}
                value={filterCikkcsoport}
                defaultOptions
                isClearable
                getOptionValue={option => option.id}
                getOptionLabel={option => option.nev}
              />
            </div>
            <div className="col-md-3">
              <SelectField
                label='Cikk:'
                name="filterCikk"
                id="filterCikk"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                onChange={v => this.setState({ filterCikk: v })}
                onInputChange={_.debounce(this.handleUpdateCikkInput, 1000)}
                isLoading={this.state.cikkLoading}
                options={this.state.cikkJson}
                value={filterCikk}
                isClearable
                getOptionValue={option => option.id}
                getOptionLabel={option => option.megnevezes}
              />
            </div>
            <div className="col-md-2" style={{ paddingTop: '28px' }}>
              <ProgressButton color="primary" id="save" loading={this.state.listLoadingButton} onClick={e => this.updateTable(e)}>Keresés</ProgressButton>
              {' '}
            </div>
          </div>
        </RFForm>
      </React.Fragment>
    );
  }

  addRaktarRow = () => {
    this.setState(prevState => ({
      raktarCollapseIsOpen: true,
      formRaktarRows: [...prevState.formRaktarRows, []]
    }));
  }

  handleRaktarSelect = (selectedRaktarArray, idx) => {
    this.setState(prevState => {
      let formRaktarRows = [...prevState.formRaktarRows];
      formRaktarRows.splice(idx, 1, selectedRaktarArray)
      return { formRaktarRows }
    });
  }

  toggleraktarCollapseIsOpen = () => {
    this.setState(prevState => ({ raktarCollapseIsOpen: !prevState.raktarCollapseIsOpen }));
  }

  deleteRaktarRow = (idx) => {
    this.setState(prevState => {
      let { formRaktarRows, formRaktarRowsKeszletszintValues } = prevState;
      formRaktarRows.splice(idx, 1);
      formRaktarRowsKeszletszintValues.splice(idx, 1);
      return { formRaktarRows, formRaktarRowsKeszletszintValues };
    });
  }

  handleRaktarRowKeszletszintChange = (v, idx, isMin) => {
    this.setState(prevState => {
      let { formRaktarRowsKeszletszintValues } = prevState;
      if (!formRaktarRowsKeszletszintValues[idx])
        formRaktarRowsKeszletszintValues[idx] = [];
      if (isMin)
        formRaktarRowsKeszletszintValues[idx][0] = v;
      else
      formRaktarRowsKeszletszintValues[idx][1] = v;
      return { formRaktarRowsKeszletszintValues }});
  }

  filterSelectableRaktar = () => {
    return this.state.raktarJson.filter(raktar => !this.state.formRaktarRows.flatMap(raktarRow => raktarRow.map(raktar => raktar.id)).includes(raktar.id));
  }

  toggleCikkCheck = (cikkid) => {
    this.setState((prevState) => {
      let { cikkTree } = prevState;
      cikkTree.forEach((cikkcsoport) => {
        cikkcsoport.cikkek.forEach((cikk) => {
          if (cikk.id == cikkid) {
            cikk.isChecked = !cikk.isChecked;
          }
        });
      });
      return { cikkTree };
    });
  }

  addKeszletszint = (e, submitObj) => {
    let cikkIdList = [];
    this.state.cikkTree.forEach(cikkcsoport => cikkcsoport.children.forEach(cikk => { if (cikk.isChecked) cikkIdList.push(cikk.id) }))
    submitObj.cikkIdList = cikkIdList;

    let raktarList = [];
    // Adatok átformázása backend-hez, ahol raktár-készletszint párok kellenek (a felületen több raktár tartozhat egy-egy készletszinthez, UX miatt)
    for (let i = 0; i < this.state.formRaktarRows.length; i++) {
      const raktarRow = this.state.formRaktarRows[i];
      const raktarKeszletValues = this.state.formRaktarRowsKeszletszintValues[i];
      raktarRow.forEach(raktar => {
        raktarList.push({ raktarId: raktar.id, minimumKeszletszint: raktarKeszletValues && raktarKeszletValues[0], maximumKeszletszint: raktarKeszletValues && raktarKeszletValues[1] })
      });
    }
    submitObj.keszletszintRaktarBeanList = raktarList;
    this.setState({addButtonLoading: true});
    Service.addKeszletszint(submitObj, (err, res) => {
      if (!err) {
        if (this.state.filterCikkcsoport || this.state.filterCikk)
          this.updateTable();
        this.handleAddKeszletszint();
        this.props.globals.addSuccess('Készletszint hozzáadva!');
      }
      this.setState({addButtonLoading: false});
    });
  }

  editKeszletszint = (e, submitObj) => {
    submitObj.id = this.state.editObj.id;
    this.setState({modifyButtonLoading: true});
    Service.editKeszletszint(submitObj, (err, res) => {
      if (!err) {
        if (this.state.filterCikkcsoport || this.state.filterCikk)
          this.updateTable();
        this.handleEditClick();
        this.props.globals.addSuccess('Készletszint hozzáadva!');
      }
      this.setState({modifyButtonLoading: false});
    });
  }

  renderSelectedFuncButtons = (start, to, total) => {
    return(
        <span>
          {' '}
          <Button className="text-black" >
            { start } - { to } / { total } tétel megjelenítése
          </Button>
          {' '}
          {this.hasKarb() &&
            <Button type="button" color="danger" onClick={() => this.handleDeleteClick(this.state.selectedIds, true)} disabled={this.state.selectedIds.length == 0}>
                {'Csoportos törlés'}
            </Button>
          }
        </span>
    );
  }

  onRowSelectAll = (isSelected) => {
    const { keszletszintJson }  = this.state;
    if (isSelected) {
      this.setState({ selectedIds: keszletszintJson.map(ksz => ksz.id)});
    } else {
      this.setState({ selectedIds: []});
    }
  }

  onRowSelect = (keszletszint, isSelected) => {
    if (isSelected) {
      this.setState(prevState => ({ selectedIds: [...prevState.selectedIds, keszletszint.id]}));
    } else {
      this.setState(prevState => ({ selectedIds: prevState.selectedIds.filter(x => x != keszletszint.id)}));
    }
  }

  renderTable = () => {
    const selectRow = {
      selected: this.state.selectedIds,
      mode: 'checkbox',
      clickToSelect: false,
      onSelect: this.onRowSelect,
      onSelectAll: this.onRowSelectAll,
    };
    let options = {...Lib.bootstraptableProps};
    options.paginationTotalRenderer = this.renderSelectedFuncButtons;

    const columns = [
      {
        dataField: 'cikkcsoport',
        text: 'Cikkcsoport',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'cikkNev',
        text: 'Cikk neve',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      }, {
        dataField: 'mennyisegEgyseg',
        text: 'Mennyiségi egység',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'raktarNev',
        text: 'Raktár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'minimumKeszletszint',
        text: 'Minimum készletszint',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: v => NumberFormatter.addSpacesToString(v, NumberFormatter.OSSZEG),
        sort: true,
      },
      {
        dataField: 'maximumKeszletszint',
        text: 'Maximum készletszint',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: v => NumberFormatter.addSpacesToString(v, NumberFormatter.OSSZEG),
        sort: true,
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.keszletszintJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(options)}
          selectRow={selectRow}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }
 
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            {this.hasKarb() &&
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleAddKeszletszint}>Új készletszint</Button>
            }
          </div>
        </div>
        {this.renderFilters()}
        {this.state.tableStatus === 'LOAD' ? <Loader /> : <span />}
        {this.state.tableStatus === 'QUERY' ? <QueryEmptyState hasImage/> : <span />}
        {this.state.tableStatus === 'DATA' ? <DataEmptyState hasImage subtitle="Próbálj más előszűrést vagy vigyél fel új adatokat!" /> : <span />}
        <div className='mt-1'>
          {this.state.tableStatus === 'LIST' ? this.renderTable() : <span />}
          {this.state.tableStatus === 'NETW' ? (
          <NetworkEmptyState
            hasImage
            submitClick={() => this.updateTable()}
          />
          ) : <span />}
        </div>

        <Modal isOpen={this.state.modalDelete} toggle={this.handleDeleteClick} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott {this.state.modalDeleteGroup && this.state.selectedIds.length > 1 ? 'tételeket' : 'tételt'}?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} className="btn-cursor-pointer" color="primary" onClick={() => this.deleteKeszletszint(this._currentDeleteId)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.handleDeleteClick}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <RFForm
          onSubmit={this.editKeszletszint}
          modalInsert
          title={'Készletszint módosítás'}
          tagProps={{ isOpen: this.state.modalEdit, toggle: this.handleEditClick, className: this.props.className, backdrop: 'static' }}
          footer={
            <>
              <ProgressButton loading={this.state.modifyButtonLoading} className="btn-cursor-pointer" color="primary">Mentés</ProgressButton>{' '}
              <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.handleEditClick}>Mégsem</Button>
            </>
          }
        >
          <div className='row'>
            <div className='col-md-4'>
              <RFField
                label='Cikkcsoport:'
                name="cikkcsoport"
                value={this.state.editObj.cikkcsoport}
                disabled
              />
            </div>
            <div className='col-md-4'>
              <RFField
                label='Cikk:'
                name="cikk"
                value={this.state.editObj.cikkNev}
                disabled
              />
            </div>
            <div className='col-md-4'>
              <RFField
                label='Raktár:'
                name="raktar"
                value={this.state.editObj.raktarNev}
                disabled
              />
            </div>
            <div className='w-100 mb-1' />
            <div className='col-md-6'>
              <SlaveAvInput
                label='Minimum készletszint:'
                name="minimumKeszletszint"
                value={this.state.editObj.minimumKeszletszint}
                szuroTipus={NumberFormatter.OSSZEG}
              />
            </div>
            <div className='col-md-6'>
              <SlaveAvInput
                label='Maximum készletszint:'
                name="maximumKeszletszint"
                value={this.state.editObj.maximumKeszletszint}
                szuroTipus={NumberFormatter.OSSZEG}
              />
            </div>
          </div>
        </RFForm>

        <RFForm
          onSubmit={this.addKeszletszint}
          modalInsert
          title={'Készletszint felvitel'}
          tagProps={{ isOpen: this.state.modalInsert, toggle: this.handleAddKeszletszint, className: this.props.className, backdrop: 'static', size: 'lg' }}
          footer={
            <>
              <ProgressButton loading={this.state.addButtonLoading} className="btn-cursor-pointer" color="primary" disabled={!this.state.cikkTree?.some(cikkcsoport => cikkcsoport.children?.some(cikk => cikk.isChecked))}>Mentés</ProgressButton>{' '}
              <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.handleAddKeszletszint}>Mégsem</Button>
            </>
          }
        >
          <div className='row'>
            <div className='col-md-5'>
              <SelectField
                label='Cikkcsoport:'
                name="cikkcsoport"
                id="cikkcsoport"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                options={this.state.cikkcsoportJson}
                onChange={this.handleCikkCsoportSelect}
                defaultOptions
                isClearable
                isMulti
                getOptionValue={option => option.id}
                getOptionLabel={option => option.nev}
              />
            </div>
            <div className='col-md-5'>
              <SelectField
                label='Cikk:'
                name="cikk"
                id="cikk"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                onInputChange={_.debounce(this.handleUpdateCikkInput, 1000)}
                onChange={this.handleCikkSelect}
                isLoading={this.state.cikkLoading}
                options={this.state.cikkJson}
                tooltip={<CustomTooltip text={getTooltip('keszletszintcikk')} id="keszletszintcikkTT" />}
                isClearable
                isMulti
                getOptionValue={option => option.id}
                getOptionLabel={option => option.megnevezes + ' (' + option.mennyisegiEgyseg + ')'}
              />
            </div>
            <div className='col-auto' style={{ paddingTop: 30 }}>
              <ProgressButton loading={this.state.lekerdezesButtonLoading} type="button" color="primary" onClick={this.listCikk}>
                <i className="fa fa-search" aria-hidden="true" />
              </ProgressButton>
            </div>
            <div className='w-100 mb-1' />
            <div className='col-md-5'>
              <SlaveAvInput
                label='Minimum készletszint:'
                tooltip={<CustomTooltip text={getTooltip('keszletszintfield')} id="keszletszintfieldTT" />}
                name="minimumKeszletszint"
                szuroTipus={NumberFormatter.OSSZEG}
              />
            </div>
            <div className='col-md-5'>
              <SlaveAvInput
                label='Maximum készletszint:'
                tooltip={<CustomTooltip text={getTooltip('keszletszintfield')} id="keszletszintfieldTT" />}
                name="maximumKeszletszint"
                szuroTipus={NumberFormatter.OSSZEG}
              />
            </div>
            <div className='w-100 mb-1' />
            <div className='col-auto'>
              <Button type='button' color='success' onClick={this.addRaktarRow}>
                Raktárankénti készletszint hozzáadása
              </Button>
            </div>
            <div className='col-auto'>
              <i className={"fa fa-2x fa-caret-" + (this.state.raktarCollapseIsOpen ? 'down' : 'up')} style={{ paddingTop: 4 }} aria-hidden="true" onClick={this.toggleraktarCollapseIsOpen} />
            </div>
            <div className='col-auto pl-0'>
              <div style={{ paddingTop: 5 }}>
                {'(' + this.state.formRaktarRows.length + ' tétel)'}
              </div>
            </div>
            <div className='w-100 mb-1' />
              <Collapse isOpen={this.state.raktarCollapseIsOpen}>
                {this.state.formRaktarRows.map((row, idx) => {
                  return <div className='row col-auto ml-1 mr-1'>
                    <div className='col'>
                      <SelectField
                        label='Raktár(ak):'
                        name={"raktar"+idx}
                        placeholder="Kezdj el gépelni..."
                        noOptionsMessage={() => 'Nincs keresési eredmény'}
                        searchPromptText="Kezdj el gépelni..."
                        loadingMessage={() => 'Keresés...'}
                        options={this.filterSelectableRaktar()}
                        onChange={array => this.handleRaktarSelect(array, idx)}
                        value={this.state.formRaktarRows[idx]}
                        isClearable
                        isMulti
                        getOptionValue={option => option.id}
                        getOptionLabel={option => option.nev}
                      />
                    </div>
                    <div className='col'>
                      <SlaveAvInput
                        label='Minimum készletszint:'
                        onChange={(e,v) => this.handleRaktarRowKeszletszintChange(v, idx, true)}
                        forcedValue={this.state.formRaktarRowsKeszletszintValues[idx] && this.state.formRaktarRowsKeszletszintValues[idx][0]}
                        name={"minimumKeszletszint" + idx}
                        szuroTipus={NumberFormatter.OSSZEG}
                      />
                    </div>
                    <div className='col'>
                      <SlaveAvInput
                        label='Maximum készletszint:'
                        onChange={(e,v) => this.handleRaktarRowKeszletszintChange(v, idx, false)}
                        forcedValue={this.state.formRaktarRowsKeszletszintValues[idx] && this.state.formRaktarRowsKeszletszintValues[idx][1]}
                        name={"maximumKeszletszint" + idx}
                        szuroTipus={NumberFormatter.OSSZEG}
                      />
                    </div>
                    <div className='col-auto'>
                      <i className="fa fa-trash" style={{ paddingTop: 38 }} aria-hidden="true" onClick={() => this.deleteRaktarRow(idx)} />
                    </div>
                  </div>
                })}
              </Collapse>
            <div className='w-100 mb-1' />
            <div className='col-md-12'>
              <Treeview
                data={this.state.cikkTree}
                onUpdateCb={(updatedData) => {
                  this.setState({ cikkTree: updatedData });
                }}
                isCheckable={(node, depth) => {
                  // hide checkbox for all nodes of depth 1
                  // or for node with the id of `1`
                  // NOTE: The highest depth is 0, node children are depth+1
                  if (depth === 2) {
                    return false;
                  }
                  return true;
                }}
                onCheckToggleCb={(node, arrayOfNodes, depth) => {
                  const nodeCount = arrayOfNodes.length;
                  const status = (arrayOfNodes[0].isChecked) ? 'checked' : 'unchecked';
                  // alert(`${nodeCount} node(s) will be ${status} ${JSON.stringify(arrayOfNodes[0])} `);
                  if (Array.isArray(arrayOfNodes[0].children)) {
                    this.setState((prevState) => {
                      const checkState = arrayOfNodes[0].isChecked;
                      let cikkTree = JSON.parse(JSON.stringify(prevState.cikkTree));

                      cikkTree.forEach((cikkcsoport) => {
                        if (cikkcsoport.id == node.id) {
                          cikkcsoport.isChecked = checkState;
                          node.cikkek.forEach((cikkNode) => {
                            cikkcsoport.cikkek.forEach((cikk) => {
                              if (cikk.id == cikkNode.id) {
                                cikk.isChecked = checkState;
                              }
                            });
                            cikkcsoport.children.forEach((cikk) => {
                              if (cikk.id == cikkNode.id) {
                                cikk.isChecked = checkState;
                              }
                            });
                          });
                        }
                      });
                      this.setState({ cikkTree });
                      return { cikkTree };
                    });
                  } else {
                    this.toggleCikkCheck(arrayOfNodes[0].id);
                  }
                }}
              />
            </div>
          </div>
        </RFForm>

      </div>
    );
  }
}

export default KeszletszintLista;